import { gql } from '@apollo/client';
import React from 'react';
import type { VerificationEntries_VerificationEntriesFragment } from '../graphql/generated/graphqlTypes';
import styles from './VerificationEntries.module.scss';
import VerificationEntry from './VerificationEntry';

const VERIFICATION_ENTRIES_FRAGMENT = gql`
  fragment VerificationEntries_verificationEntries on VerificationEntry {
    id
    ...VerificationEntry_verificationEntry
  }
  ${VerificationEntry.fragments.verificationEntry}
`;

interface VerificationEntriesProps {
  verificationEntries: VerificationEntries_VerificationEntriesFragment[];
}

const VerificationEntries = ({
  verificationEntries,
}: VerificationEntriesProps) => (
  <>
    {verificationEntries.map((verificationEntry) => (
      <div className={styles.verificationEntry} key={verificationEntry.id}>
        <VerificationEntry verificationEntry={verificationEntry} />
      </div>
    ))}
  </>
);

VerificationEntries.fragments = {
  verificationEntries: VERIFICATION_ENTRIES_FRAGMENT,
};

export default VerificationEntries;
